/**
 * CompletionRing — small circular progress that grows as the applicant
 * fills out fields.  Lives in the page header.
 */
import React from 'react';

export function CompletionRing({ percent, size = 44 }) {
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  const cx = size / 2;
  const safe = Math.max(0, Math.min(100, Math.round(percent || 0)));
  return (
    <svg viewBox={`0 0 ${size} ${size}`}
      style={{ width: size, height: size }}
      data-testid="completion-ring">
      <circle cx={cx} cy={cx} r={r}
        fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="3" />
      <circle cx={cx} cy={cx} r={r}
        fill="none" stroke="url(#cr-grad)" strokeWidth="3"
        strokeDasharray={c}
        strokeDashoffset={c * (1 - safe / 100)}
        strokeLinecap="round"
        transform={`rotate(-90 ${cx} ${cx})`}
        style={{ transition: 'stroke-dashoffset 0.6s cubic-bezier(.2,.9,.3,1)' }} />
      <text x={cx} y={cx + 4} textAnchor="middle"
        fontSize="11" fontWeight="900" fill="#F59E0B"
        style={{ fontFamily: 'Outfit, sans-serif' }}>
        {safe}%
      </text>
      <defs>
        <linearGradient id="cr-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#CD040B" />
          <stop offset="100%" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
    </svg>
  );
}
